'use strict';

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = require('react');

var React__default = _interopDefault(React);

var defaultState = {
  descendsFromTooltip: false
};
var TooltipContext = /*#__PURE__*/React.createContext(undefined);
/**
 * Component to indicate to descentent components that they are wrapped by a
 * `Tooltip`.
 */

var TooltipContextProvider = function TooltipContextProvider(_a) {
  var children = _a.children,
      descendsFromTooltip = _a.descendsFromTooltip;
  var state = React.useMemo(function () {
    return {
      descendsFromTooltip: descendsFromTooltip !== null && descendsFromTooltip !== void 0 ? descendsFromTooltip : defaultState.descendsFromTooltip
    };
  }, [descendsFromTooltip]);
  return /*#__PURE__*/React.createElement(TooltipContext.Provider, {
    value: state
  }, children);
};
/**
 * Hook to extract values of `TooltipContext` with defaults applied.
 *
 * This will _not_ `throw` if used outside of a `TooltipContextProvider`.
 */


function useTooltipContext() {
  var _a;

  return (_a = React.useContext(TooltipContext)) !== null && _a !== void 0 ? _a : defaultState;
}

exports.TooltipContextProvider = TooltipContextProvider;
exports.useTooltipContext = useTooltipContext;